import React from "react";
import { Link } from "gatsby";

const MenuLink = ({ href, name, external = false }) => {
  if (external)
    return (
      <a
        className="footer__navigation-link"
        key={href}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        {name}
      </a>
    );

  return (
    <Link
      to={href}
      className="footer__navigation-link"
      activeClassName="footer__navigation-link--active"
      key={href}
    >
      {name}
    </Link>
  );
};

export default MenuLink;
